import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { canAccessRoute } from "../Utils/access/permissionHelpers";

/**
 * Auth (session) + optional permission check from /me/access (Redux + localStorage).
 * Use without `requiredAny` / `requirePrivileged` to mirror PrivateRoute.
 */
const PermissionRoute = ({
  children,
  requiredAny,
  requirePrivileged,
  orPrivilege,
}) => {
  const permissionKeys = useSelector((s) => s.access?.permissionKeys) || [];

  if (!localStorage.getItem("auth-token")) {
    return <Navigate to="/login" replace />;
  }

  if (
    !canAccessRoute({
      permissionKeys,
      requiredAny,
      requirePrivileged,
      orPrivilege,
    })
  ) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PermissionRoute;
